// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetCampaignFieldMappingByIdRequestModel from '../../model/get-campaign-field-mapping-by-id-request-model';
import GetCampaignFieldMappingByIdRequestDTO from '../dto/get-campaign-field-mapping-by-id-request-dto';
import dtoSchema from '../schemas/get-campaign-field-mapping-by-id-request-schema';

export default abstract class GetCampaignFieldMappingByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetCampaignFieldMappingByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetCampaignFieldMappingByIdRequestDTO>): GetCampaignFieldMappingByIdRequestModel;
  static toModel(dto: DeepPartial<GetCampaignFieldMappingByIdRequestDTO> | undefined | null): GetCampaignFieldMappingByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetCampaignFieldMappingByIdRequestDTO> | undefined | null): GetCampaignFieldMappingByIdRequestModel | undefined {
    return dto ? new GetCampaignFieldMappingByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetCampaignFieldMappingByIdRequestModel> | GetCampaignFieldMappingByIdRequestModel): GetCampaignFieldMappingByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetCampaignFieldMappingByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetCampaignFieldMappingByIdRequestModel, can not map to GetCampaignFieldMappingByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
